import { SxProps, Theme } from '@mui/material';
import theme from '../../../shared/theme';

export function getStyles(isDesktopOrLaptop: boolean):  ({ [key:string]: SxProps<Theme> }) {
    return {
        header: {
          display: 'flex',
          justifyContent: 'center'
        },
        pageTitle: {
          fontSize: 28,
          fontWeight: 800
        },
        form: {
          display: 'flex',
          flexDirection: 'column',
          flex: 6,
          maxWidth: "100%"
        },
        formItem: {
          marginBottom: theme.spacing(2)
        },
        contentBody: {
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: isDesktopOrLaptop ? 'row' : 'column',
          marginTop: theme.spacing(2),
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2)
        },
        description: {
          display: 'flex',
          flexDirection: 'column',
          flex: 6,
          maxWidth: '100%',
          paddingLeft: isDesktopOrLaptop ? theme.spacing(10) : 0,
          marginTop: isDesktopOrLaptop ? 0 : theme.spacing(4)
        },
        addressInput: {
          marginTop: theme.spacing(2)
        },
        addressAutocomplete: {
          marginTop: theme.spacing(1)
        },
        tableCell: {
          padding: '8px'
        }
      };
};
